import RestResource from "@/api/rest/rest-resource";
import {athubAxios} from "@/util";
import {ORGANIZATION_SERVER} from "@/api";

const userRole = new RestResource({server: ORGANIZATION_SERVER, resource: 'userRole'});

userRole.userPage = (pageSearch) => {
    let url = `${ORGANIZATION_SERVER}/userRole/user/page`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, pageSearch).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

// userRole.allRolesByUserId = (assessmentConf) => {
//     let url = `${ORGANIZATION_SERVER}/userRole/allRolesByUserId`;
//     return new Promise((resolve, reject) => {
//         athubAxios.post(url, assessmentConf).then(responseBody => {
//             if (responseBody.status == 200) {
//                 resolve(responseBody.data);
//             }
//         }).catch(error => {
//             reject(error);
//         });
//     });
// }

userRole.batchAdd = (userRoles) => {
    let userId = userRoles[0].userId;
    let roleIds = userRoles.map(e => e.roleId);
    let url = `${ORGANIZATION_SERVER}/userRole/bind/userid/${userId}`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, roleIds).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default userRole;